import React, { useState } from 'react';
import supabase from '../../supabase/supabase';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export default function AuthScreen() {
  const [isLogin, setIsLogin] = useState(true);
  const [isReset, setIsReset] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    
    try {
      if (isReset) {
        const { error } = await supabase.auth.resetPasswordForEmail(email);
        if (error) throw error;
        setMessage('Check your email for the reset link!');
      } else if (isLogin) {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
      } else {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setMessage('Account created! You can now log in.');
        setIsLogin(true);
      }
    } catch (err) {
      setMessage(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-app-bg flex items-center justify-center p-4 font-sans">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-app-surface border border-app-border rounded-xl shadow-2xl overflow-hidden"
      >
        <div className="p-8">
          <div className="flex flex-col items-center mb-8">
            <div className="bg-white rounded-2xl p-4 shadow-sm mb-6">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/981ecb6892631c31e92fca6d10d0332603596e5d429fd99cee63046a83be378b4365dffb7696bc6c52f453f1ea7f8977/images/aW1hZ2UvcG5n/4b0d0eb086c78be5a6191d6981f9870f.png" 
                alt="SharePrepare Toucan" 
                className="h-32 object-contain" 
              />
            </div>
            <h1 className="text-2xl font-bold">SharePrepare Toucan</h1>
            <p className="text-app-muted text-sm mt-1">Professional Terminal for Active Traders</p>
          </div>

          <form onSubmit={handleAuth} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-app-muted uppercase tracking-wider mb-1">Email Address</label>
              <input 
                type="email" 
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full bg-app-bg border border-app-border rounded-lg px-4 py-3 focus:border-app-accent outline-none transition-colors"
                placeholder="trader@market.com"
              />
            </div>
            
            {!isReset && (
              <div>
                <label className="block text-xs font-semibold text-app-muted uppercase tracking-wider mb-1">Password</label>
                <input 
                  type="password" 
                  required
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  className="w-full bg-app-bg border border-app-border rounded-lg px-4 py-3 focus:border-app-accent outline-none transition-colors"
                  placeholder="••••••••"
                />
              </div>
            )}

            {message && (
              <div className={`p-3 rounded-lg text-sm ${
                message.includes('Check') || message.includes('created') 
                  ? 'bg-app-green/10 text-app-green border border-app-green/20' 
                  : 'bg-app-red/10 text-app-red border border-app-red/20'
              }`}>
                {message}
              </div>
            )}

            <button 
              disabled={loading}
              className="w-full bg-app-accent hover:bg-yellow-500 text-black font-bold py-3 rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              {loading ? <FiIcons.FiLoader className="animate-spin" /> : null}
              {isReset ? 'Send Reset Link' : isLogin ? 'Sign In' : 'Create Account'}
            </button>
          </form>

          <div className="mt-6 flex flex-col gap-3 text-center">
            <button 
              onClick={() => { setIsReset(!isReset); setMessage(''); }}
              className="text-sm text-app-muted hover:text-app-accent transition-colors"
            >
              {isReset ? 'Back to Login' : 'Forgot Password?'}
            </button>
            
            {!isReset && (
              <button 
                onClick={() => { setIsLogin(!isLogin); setMessage(''); }}
                className="text-sm text-app-text"
              >
                {isLogin ? "Don't have an account? " : "Already have an account? "}
                <span className="text-app-accent font-semibold">{isLogin ? 'Sign Up' : 'Log In'}</span>
              </button>
            )}
          </div>
        </div>
      </motion.div>
    </div>
  );
}